import React, { useCallback, useState } from "react";
import "./css/reports.css";
import Header from "./components/header";
import TemplateData from "./components/templatedata";
import { CreateTemplate } from "./components/CreateTemplate/CreateTempate";
const Reports = ({ isPermitted }) => {
  const [showCreateTemplate, setShowCreateTemplate] = React.useState(false);
  const [refreshTemplateData, setRefreshTemplateData] = useState(false);
  const handleCreateTemplate = useCallback(() => {
    setShowCreateTemplate(!showCreateTemplate);
  }, [showCreateTemplate]);
  return (
    <div className="main-report-screen">
      {showCreateTemplate && (
        <CreateTemplate
          setRefreshTemplateData={setRefreshTemplateData}
          handleCreateTemplate={handleCreateTemplate}
        />
      )}
      <Header
        isPermitted={isPermitted}
        handleCreateTemplate={handleCreateTemplate}
      />
      <TemplateData
        handleCreateTemplate={handleCreateTemplate}
        refreshTemplateData={refreshTemplateData}
        setRefreshTemplateData={setRefreshTemplateData}
      />
    </div>
  );
};

export default Reports;
